/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Work_0_BadgeInputs */

const en_svc_retainer_work_0_badge = /** @type {(inputs: Svc_Retainer_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live product, kept live`)
};

const ar_svc_retainer_work_0_badge = /** @type {(inputs: Svc_Retainer_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منتج مباشر يبقى مباشرا`)
};

const bn_svc_retainer_work_0_badge = /** @type {(inputs: Svc_Retainer_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লাইভ প্রোডাক্ট, লাইভ রাখা`)
};

const de_svc_retainer_work_0_badge = /** @type {(inputs: Svc_Retainer_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Produkt, live gehalten`)
};

const es_svc_retainer_work_0_badge = /** @type {(inputs: Svc_Retainer_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producto en vivo, mantenido en vivo`)
};

const fr_svc_retainer_work_0_badge = /** @type {(inputs: Svc_Retainer_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produit en ligne, gardé en ligne`)
};

const pt_svc_retainer_work_0_badge = /** @type {(inputs: Svc_Retainer_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produto no ar, mantido no ar`)
};

const zh_svc_retainer_work_0_badge = /** @type {(inputs: Svc_Retainer_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`线上产品，保持在线`)
};

const tr_svc_retainer_work_0_badge = /** @type {(inputs: Svc_Retainer_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı ürün, canlı tutulur`)
};

const ru_svc_retainer_work_0_badge = /** @type {(inputs: Svc_Retainer_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Живой продукт, остаётся живым`)
};

const pl_svc_retainer_work_0_badge = /** @type {(inputs: Svc_Retainer_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żywy produkt, trzymany przy życiu`)
};

/**
* | output |
* | --- |
* | "Live product, kept live" |
*
* @param {Svc_Retainer_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_retainer_work_0_badge = /** @type {((inputs?: Svc_Retainer_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_retainer_work_0_badge(inputs)
	if (locale === "de") return de_svc_retainer_work_0_badge(inputs)
	if (locale === "es") return es_svc_retainer_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_retainer_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_retainer_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_retainer_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_retainer_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_retainer_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_retainer_work_0_badge(inputs)
	return en_svc_retainer_work_0_badge(inputs)
});